import React from 'react';
import styled from 'styled-components';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import ListParagraph from 'web-ui-kit/ProductDetails/components/ListParagraph';
import LongParagraph from 'web-ui-kit/ProductDetails/components/LongParagraph';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

var PAINT_OVERVIEW = "The paint colors in your designs will appear different depending on your screen and real-life lighting conditions. Prior to painting, we recommend purchasing sample paint and applying swatches of the paint on one or more walls in your space to confirm your paint color and finish selection.";
var WALLPAPER_DISCLOSURE = "Talk to a professional about the amount of wallpaper to buy, where to place pattern seams, and for installation.";
/**
 * Product physical details and overview content block.
 */

function PhysicalDetailsAndOverview(_ref) {
  var _ref$isCustomPropUI = _ref.isCustomPropUI,
      isCustomPropUI = _ref$isCustomPropUI === void 0 ? false : _ref$isCustomPropUI,
      _ref$isMaterial = _ref.isMaterial,
      isMaterial = _ref$isMaterial === void 0 ? false : _ref$isMaterial,
      _ref$product = _ref.product,
      product = _ref$product === void 0 ? {} : _ref$product;
  var description = product.description,
      id = product.id,
      physicalDetails = product.physicalDetails,
      externalId = product.externalId;
  var dimensionsStr = computeDims(physicalDetails);
  var detailsList = computeProductDetails(physicalDetails, externalId, isMaterial);
  var isWallpaper = ['Wallpaper', 'Wallpaper - Installation'].includes(product.mainType);
  var visibleData = description || dimensionsStr || detailsList.length > 0;

  if (!visibleData) {
    return null;
  }

  var Container = styles.Container;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": "ddo-block"
    }, isWallpaper &&
    /*#__PURE__*/
    React.createElement(ListParagraph, {
      id: "wallpaper",
      heading: "Before you buy",
      list: [WALLPAPER_DISCLOSURE]
    }), !isMaterial && dimensionsStr &&
    /*#__PURE__*/
    React.createElement(ListParagraph, {
      id: "dimensions",
      heading: "Dimensions",
      list: [dimensionsStr]
    }), detailsList.length > 0 && !isCustomPropUI &&
    /*#__PURE__*/
    React.createElement(ListParagraph, {
      id: "details",
      heading: "Product details",
      list: detailsList
    }), description && !isCustomPropUI &&
    /*#__PURE__*/
    React.createElement(LongParagraph, {
      key: id,
      id: "overview",
      heading: "Overview",
      lineTruncateCnt: 5,
      paragraph: description
    }), isMaterial && !description && !isCustomPropUI &&
    /*#__PURE__*/
    React.createElement(LongParagraph, {
      id: "paint",
      heading: "Overview",
      lineTruncateCnt: 6,
      paragraph: PAINT_OVERVIEW
    }))
  );
}
/** Helpers */


function computeDims() {
  var physicalDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var depth = physicalDetails.depth,
      height = physicalDetails.height,
      width = physicalDetails.width;
  var dims = [];

  if (height) {
    dims.push("".concat(height, "\"H"));
  }

  if (width) {
    dims.push("".concat(width, "\"W"));
  }

  if (depth) {
    dims.push("".concat(depth, "\"L"));
  }

  return dims.join(' x ');
}

function computeProductDetails() {
  var physicalDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var externalId = arguments.length > 1 ? arguments[1] : undefined;
  var isMaterial = arguments.length > 2 ? arguments[2] : undefined;
  var assemblyRequired = physicalDetails.assemblyRequired,
      careInstructions = physicalDetails.careInstructions,
      color = physicalDetails.color,
      finish = physicalDetails.finish,
      material = physicalDetails.material,
      originCountry = physicalDetails.originCountry;
  var deets = [];

  if (color) {
    deets.push("Color: ".concat(toTitleCase(color)));
  }

  if (externalId && isMaterial) {
    deets.push("Retailer SKU: ".concat(externalId));
  }

  if (material) {
    deets.push("Material: ".concat(toTitleCase(material)));
  }

  if (finish) {
    deets.push("Finish: ".concat(toTitleCase(finish)));
  }

  if (careInstructions) {
    deets.push("Care Instructions: ".concat(careInstructions));
  }

  if (assemblyRequired) {
    deets.push("Assembly Required: ".concat(toTitleCase(assemblyRequired)));
  }

  if (originCountry) {
    deets.push("Country of Origin: ".concat(originCountry));
  }

  return deets;
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
/** Styles */


var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n\n    padding: 1.5rem 1rem;\n\n    ", " {\n      padding: 1.5rem 0;\n    }\n  "])), MQ_FOR_TABLET_LANDSCAPE_UP)
};
export default PhysicalDetailsAndOverview;